module.exports = __webpack_public_path__ + "static/us_napa_green-49d7df107853782ec281036383d5260e.png";